(() => {
  'use strict';

  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-sort-select]');
    if (!select) return;
    const form = select.form || select.closest('form');
    if (form) form.requestSubmit();
  });

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-load-more]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.classList.contains('is-loading')) return;
    trigger.classList.add('is-loading');
    trigger.setAttribute('aria-disabled', 'true');

    try {
      const response = await fetch(trigger.href, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('Unable to load more products');
      const html = await response.text();
      const incomingDocument = new DOMParser().parseFromString(html, 'text/html');
      const incomingGrid = incomingDocument.querySelector('[data-product-grid]');
      const currentGrid = document.querySelector('[data-product-grid]');
      const incomingPagination = incomingDocument.querySelector('[data-pagination]');
      const currentPagination = document.querySelector('[data-pagination]');

      if (!incomingGrid || !currentGrid) throw new Error('Unable to load more products');
      const items = Array.from(incomingGrid.children);
      items.forEach((item) => currentGrid.appendChild(item));
      if (currentPagination) {
        if (incomingPagination) currentPagination.replaceWith(incomingPagination);
        else currentPagination.remove();
      }
      window.JamairoTheme?.bind(currentGrid);
      const firstNewLink = items[0]?.querySelector('a, button');
      firstNewLink?.focus({ preventScroll: true });
      window.JamairoTheme?.announce(`${items.length} products loaded`);
    } catch (error) {
      window.JamairoTheme?.announce(error.message);
      window.location.assign(trigger.href);
    } finally {
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('aria-disabled');
    }
  });
})();
